module.exports = __webpack_public_path__ + "static/PrestonHollow-f82e032d63d374f19c86e3fbeae203c8.jpg";